export const messages = {
  title: { id: 'admin/promotions.form.conditions.utmi' },
  campaign: { id: 'admin/promotions.form.conditions.utmi.campaign' },
  subtitle: { id: 'admin/promotions.form.conditions.utmi.campaign.subtitle' },
  invalidChars: { id: 'admin/promotions.form.conditions.utm.invalid' },
  connector: { id: 'admin/promotions.form.rule.connector.and' },
  viewDescription: {
    id: 'admin/promotions.form.conditions.utm.cp.description',
  },
  moreInformation: {
    id: 'admin/promotions.links.conditions.utmi.more-information',
  },
}
